/* FRATERNAL — quick add from a product card. Choose a size and add to the bag without
   opening the product page (Jalen 2026-10-15).

   The markup is a real <form action="/cart/add" method="post"> with submit buttons carrying
   name="id". With JS off it posts normally and still works. This file intercepts, posts to
   /cart/add.js, and keeps the shopper on the page. */
(function () {
  var d = document;

  function setBag(count) {
    d.querySelectorAll('.bag__n').forEach(function (el) { el.textContent = count; });
  }

  function closeAll(except) {
    d.querySelectorAll('[data-frt-qa]').forEach(function (qa) {
      if (qa === except) return;
      var panel = qa.querySelector('[data-frt-qa-form]');
      var btn = qa.querySelector('[data-frt-qa-open]');
      if (panel) panel.hidden = true;
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.textContent = 'QUICK ADD'; }
    });
  }

  d.addEventListener('click', function (e) {
    var open = e.target.closest('[data-frt-qa-open]');
    if (!open) { closeAll(null); return; }
    var qa = open.closest('[data-frt-qa]');
    var panel = qa.querySelector('[data-frt-qa-form]');
    var isOpen = !panel.hidden;
    closeAll(qa);
    panel.hidden = isOpen;
    open.setAttribute('aria-expanded', String(!isOpen));
    open.textContent = isOpen ? 'QUICK ADD' : 'PICK A SIZE';
    if (!isOpen) {
      var first = panel.querySelector('.qa__sz:not([disabled])');
      if (first) first.focus();
    }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  d.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-frt-qa-form]');
    if (!form) return;
    var btn = form.querySelector('button[type="submit"]:focus')
           || form.querySelector('button[name="id"][data-frt-pressed]');
    if (!btn) return;                       // no variant resolved — let it post normally
    e.preventDefault();
    var qa = form.closest('[data-frt-qa]');
    var opener = qa.querySelector('[data-frt-qa-open]');
    qa.classList.add('is-busy');
    // TL-018: ask for the header section back WITH the add, so the bag count repaints from
    // one round trip instead of add.js followed by a separate cart.js.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.value), quantity: 1 }],
        sections: 'frt-header,frt-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        // Repaint the drawer so it is current when they tap BAG, but do NOT open it:
        // quick add exists so a shopper can stack sizes from the grid without being
        // pulled out of the page (Jalen 2026-10-15). The PDP add opens the drawer;
        // this one deliberately stays inline with its ADDED tick.
        if (window.frtCart && res && res.sections) window.frtCart.paint(res.sections);
        // prefer the count parsed out of the returned section; fall back to cart.js only
        // if Shopify did not return it (older API, or the section was not rendered)
        var markup = res && res.sections && res.sections['frt-header'];
        if (markup) {
          var m = markup.match(/class="bag__n"[^>]*>(\d+)</);
          if (m) return { item_count: Number(m[1]) };
        }
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // clear busy BEFORE the paint that consumes it, or the card stays greyed out
        qa.classList.remove('is-busy');
        setBag(cart.item_count);
        form.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
        opener.textContent = 'ADDED ✓';
        opener.classList.add('is-added');
        setTimeout(function () {
          opener.textContent = 'QUICK ADD';
          opener.classList.remove('is-added');
        }, 2200);
      })
      .catch(function () {
        qa.classList.remove('is-busy');
        opener.textContent = 'TRY AGAIN';
        setTimeout(function () { opener.textContent = 'PICK A SIZE'; }, 2000);
      });
  });

  // record which submit button was pressed (Safari does not always set :focus in time)
  d.addEventListener('pointerdown', function (e) {
    var b = e.target.closest('.qa__sz');
    if (!b) return;
    b.closest('form').querySelectorAll('[data-frt-pressed]').forEach(function (x) { x.removeAttribute('data-frt-pressed'); });
    b.setAttribute('data-frt-pressed', '');
  });
})();
